import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { toast } from 'react-toastify'

import API from '@/api'

export default function useGoogleClient({
  setGoogleIntegrationActive,
  onGoogleConnected,
}: {
  setGoogleIntegrationActive: (boolean: boolean) => void
  onGoogleConnected?: () => Promise<void>
}): {
  setIsLoadingOAuth?: Dispatch<SetStateAction<boolean>>
  isLoadingOAuth: boolean
  tokenClient: any
} {
  const [tokenClient, setTokenClient] = useState(null)
  const [isLoadingOAuth, setIsLoadingOAuth] = useState(false)

  const gisLoaded = useCallback(() => {
    const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
    const SCOPES =
      'https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/userinfo.email'

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    const tokenClient = window.google.accounts.oauth2.initCodeClient({
      client_id: CLIENT_ID,
      scope: SCOPES,
      callback: async (resp: any) => {
        setIsLoadingOAuth(true)
        try {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          await API.postGoogleIntegration(resp.code)
          setGoogleIntegrationActive(true)
          try {
            await onGoogleConnected?.()
            toast.success('Google connected')
          } catch (error) {
            toast.error('Error to sync google details')
          } finally {
            setIsLoadingOAuth(false)
          }
        } catch (error) {
          toast.error('Error to try connect to Google')
          setIsLoadingOAuth(false)
        }
      },
    })

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    setTokenClient(tokenClient)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setGoogleIntegrationActive])

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.defer = true
    script.onload = () => {
      const event = new Event('gisLoaded')
      window.dispatchEvent(event)
    }
    document.body?.appendChild(script)

    window.addEventListener('gisLoaded', gisLoaded)

    return () => {
      window.removeEventListener('gisLoaded', gisLoaded)
      document.body?.removeChild(script)
    }
  }, [gisLoaded])

  return { setIsLoadingOAuth, isLoadingOAuth, tokenClient }
}
